/**
 * Startprogramm, das auf dem Board unter /main.py liegt.
 *
 * Warum es noetig ist
 * -------------------
 * Nach einem Soft-Reset fuehrt MicroPython `boot.py` und dann `main.py` aus.
 * Ohne diese Datei passiert nach der Uebertragung schlicht nichts: das Board
 * meldet den Neustart und zeigt die Eingabeaufforderung.
 *
 * Was es leistet
 * --------------
 * * Es startet das zuletzt vollstaendig uebertragene Projekt. Welches das ist,
 *   steht in /robot_project.json; die Datei wird erst geschrieben, wenn alle
 *   Programmdateien angekommen sind. Ein abgebrochener Upload startet deshalb
 *   kein halb ersetztes Projekt (W07).
 * * Es laesst den Roboter ohne Browser laufen: nach dem Einschalten startet
 *   dasselbe Programm (O08, G15).
 * * Es stoppt die Ansteuerung, wenn das Programm endet oder abbricht (W08).
 *   Das ist eine Absicherung, keine Garantie: bei einem harten Abbruch greift
 *   der Ueberwachungsdienst auf dem Regelkern.
 */

/** Name der Startdatei auf dem Board. */
export const LAUNCHER_PATH = "/main.py";

/** Name der Projektbeschreibung auf dem Board. */
export const MANIFEST_PATH = "/robot_project.json";

export const LAUNCHER_SOURCE = `# Startet das zuletzt uebertragene Projekt.
# Erzeugt von der Lernoberflaeche. Aenderungen hier werden beim naechsten
# Uebertragen ueberschrieben.
import json
import os
import sys


def _run():
    try:
        with open("${MANIFEST_PATH}") as handle:
            project = json.load(handle)
    except (OSError, ValueError):
        print("Kein vollstaendig uebertragenes Projekt vorhanden.")
        return

    folder = project["path"]
    main = folder + "/" + project.get("main", "main.py")

    # Damit eigene Module des Projekts importierbar sind.
    if folder not in sys.path:
        sys.path.insert(0, folder)
    try:
        os.chdir(folder)
    except OSError:
        pass

    try:
        with open(main) as handle:
            source = handle.read()
    except OSError:
        print("Programmdatei fehlt:", main)
        return

    exec(compile(source, project.get("main", "main.py"), "exec"), {"__name__": "__main__"})


try:
    _run()
finally:
    # Sicherheitsnetz: nach Programmende, Fehler oder Abbruch keine Ansteuerung
    # stehen lassen. Schlaegt das fehl, uebernimmt der Ueberwachungsdienst.
    try:
        import robot

        robot.stop()
    except Exception:
        pass
`;
